// TEMPORARY compatibility file — winicoins stub.

export function calculateWinicoins(amount, _duration) {
  // TODO: restore real conversion formula
  const n = Number(amount) || 0;
  return Math.max(0, Math.round(n * 8));
}

export async function updateUserWinicoins(_userId, _amount) {
  // TODO: restore real winicoins update
  console.warn('[winicoinsUtils TEMP] updateUserWinicoins() stub');
  return { ok: true, stub: true };
}
